import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { ADGMDatePicker, FiltersTextField, AccordionLayout, ADGMImage } from 'aurora-components';

/** ****************
Props Documentation:
--------------------
isAccordion: flag to check if accordion layout is required
datePickerProps: all the props of ADGMDatePicker
textFieldProps: all the props of ADGMTextField
***************** */

const FiltersDatePicker = ({ isAccordion, datePickerProps, textFieldProps }) => {
  const { name, value } = textFieldProps;
  const { onChange } = datePickerProps;

  const onChangeHandler = date => {
    onChange(name, moment(date).isValid() ? moment(date).format('YYYY-MM-DD') : null);
  };

  if (isAccordion) {
    return (
      <AccordionLayout title={textFieldProps?.label}>
        <ADGMDatePicker
          {...datePickerProps}
          date={moment(value).isValid() ? moment(value).format('MM/DD/YYYY') : ''}
          onChange={onChangeHandler}
          component={
            <FiltersTextField
              endAdornment={<ADGMImage name='calendar_icon.svg' alt='calendar' />}
              {...textFieldProps}
              mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
              label={null}
              value={moment(value).isValid() ? moment(value).format('DD/MM/YYYY') : ''}
            />
          }

          // component={
          //   <ADGMCalenderField
          //     {...textFieldProps}
          //     label={null}
          //     // value={value ? format(new Date(value), 'dd/MM/yyyy') : ''}
          //     value={moment(value).isValid() ? moment(value).format('DD/MM/YYYY') : ''}
          //     autoComplete='off'
          //     mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
          //     endAdornment={<img src={calenderIcon} alt='calendar' />}
          //     handleInputChange={onChangeHandler}
          //     customClasses={{
          //       label: classes?.label,
          //       field: classes?.field,
          //       input: classes?.input,
          //     }}
          //   />
          // }
        />
      </AccordionLayout>
    );
  }

  return (
    <ADGMDatePicker
      {...datePickerProps}
      onChange={onChangeHandler}
      component={
        <FiltersTextField
          endAdornment={<ADGMImage name='calendar_icon.svg' alt='calendar' />}
          {...textFieldProps}
          mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
          value={moment(value).isValid() ? moment(value).format('DD/MM/YYYY') : ''}
        />
      }

      // component={
      //   <ADGMCalenderField
      //     {...textFieldProps}
      //     value={moment(value).isValid() ? moment(value).format('DD/MM/YYYY') : ''}
      //     autoComplete='off'
      //     mask={[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]}
      //     endAdornment={<img src={calenderIcon} alt='calendar' />}
      //     handleInputChange={onChangeHandler}
      //     customClasses={{
      //       label: classes?.label,
      //       field: classes?.field,
      //       input: classes?.input,
      //     }}
      //   />
      // }
    />
  );
};

FiltersDatePicker.propTypes = {
  classes: PropTypes.object.isRequired,
  isAccordion: PropTypes.bool,
  datePickerProps: PropTypes.object,
  textFieldProps: PropTypes.object,
};

FiltersDatePicker.defaultProps = {
  isAccordion: false,
  datePickerProps: {},
  textFieldProps: {},
};

export default FiltersDatePicker;
